import { Component, Input, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { UserPreferences } from '@tv3/store/user-preferences/user-preferences.model'
import { selectUserPreferences } from '@tv3/store/user-preferences/user-preferences.selectors'
import { UpdateUserPreferences } from '@tv3/store/user-preferences/user-preferences.actions'
import * as fromRoot from '@tv3/store/state'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'
import { selectSome } from '@tokeet/tv3-platform'
import { TooltipPosition } from '@angular/material/tooltip'

@Component({
  selector: 'app-default-calendar-indicator',
  templateUrl: './default-calendar-indicator.component.html',
  styleUrls: ['./default-calendar-indicator.component.scss'],
})
export class DefaultCalendarIndicatorComponent extends Destroyable implements OnInit {
  @Input() calendarName

  @Input() tooltipPosition: TooltipPosition = 'right'

  userPreference: UserPreferences
  isDefaultCalendarView = false

  constructor(private store: Store<fromRoot.State>) {
    super()
  }

  ngOnInit() {
    this.store.pipe(selectSome(selectUserPreferences), untilDestroy(this)).subscribe((userPref: UserPreferences) => {
      this.userPreference = userPref
      this.isDefaultCalendarView = this.userPreference.defaultCalendar === this.calendarName
    })
  }

  setAsDefaultCalendarView() {
    if (this.isDefaultCalendarView) {
      return
    }
    const payload = {
      id: this.userPreference.id,
      form: { default_calendar: this.calendarName },
    }
    this.store.dispatch(UpdateUserPreferences(payload))
  }
}
